import { ActivatedRoute, Router } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RouterService {
  constructor(private router: Router, private activeRoute: ActivatedRoute) {}

  /** Functions that allow to change pages passing data without the need to be viewed in the url*/

  /** Use this method to navigate towards a parent path in router service list
   * example => navigateTo('login')
   */
  public navigateTo(view: string, data?: any) {
    let route;
    route = this.router.config.find((c) => c.path === view);
    if (data) {
      route.data = data;
    }
    this.router.navigate([view]).then(() => {
      if (route) {
        route.data = {};
      }
    });
  }

  public childRoutes(rrs, baseRoute, oob) {
    for (var i = 0; i < rrs.length; i++) {
      var rr = rrs[i];
      oob[baseRoute + '/' + rr.path] = rr;
      if (rr.children) {
        this.childRoutes(rr.children, baseRoute + '/' + rr.path, oob);
      }
    }
    return oob;
  }
}
